export default "__VITE_ASSET__BR$9Gl1X__"